/**
 * 判断是否在微信客户端
 * @returns true/false
 */
export const isWeChat = (): boolean => {
  return navigator.userAgent.toLowerCase().indexOf("micromessenger") != -1;
};

/**
 * 手机号脱敏
 */
export const mobileHide = (mobile: string): string => {
  if (mobile == null || mobile == undefined || mobile == "") {
    return "";
  }
  return `${mobile.substring(0, 3)}******${mobile.substring(
    mobile.length - 2
  )}`;
};

// tag样式
export const setTagType = (datas: any, value: string | number): string => {
  if (datas) {
    if (datas.length) {
      let listClass = "";
      for (let i = 0; i < datas.length; i++) {
        if (datas[i].dictValue == value) {
          if (datas[i].listClass == "default" || datas[i].listClass == "info") {
            listClass = "primary";
          } else {
            listClass = datas[i].listClass;
          }
        }
      }
      return listClass;
    }
    return "";
  }
  return "";
};

// 回显数据字典
export const selectDictLabel = (datas: any, value: string | number): string => {
  if (datas) {
    if (datas.length) {
      let label = "";
      for (let i = 0; i < datas.length; i++) {
        if (datas[i].dictValue == value) {
          label = datas[i].dictLabel;
        }
      }
      return label;
    }
    return "";
  }
  return "";
};
